import * as React from 'react';
import './index.scss';
import { fetch, GetGuildPkDetailRsp, GetPkStageRsp, GuildPkRoundItem, RankItemMock } from '@/fetch.ts';
import None from '@hooks/web/public/none.tsx';
import Page from '@hooks/web/public/page.tsx';
import Swiper from 'swiper/js/swiper.min.js';

import PkItem from '@hooks/web/public/pkItem.tsx';
import 'swiper/swiper.scss';
const { useEffect, useState, useContext } = React;
interface Props {
  iStage: number,
  from: number,
  iRevive: number,
}
const PkRank: React.FC<Props> = props => {

  const [current, Current] = useState<number>(0);
  const [roundKey, RoundKey] = useState<number[] | string[]>([]);
  const [roundValue, RoundValue] = useState<number[]>([]);
  const [iDay, IDay] = useState<number>(0);
  const [iRound, IRound] = useState<number>(0);
  const [iDayDefault, IDayDefault] = useState<number>(0);
  const [iRoundDefault, IRoundDefault] = useState<number>(0);
  useEffect(() => {
    RoundKey([]);
    RoundValue([]);
    IDay(0);
    IRound(0);
    IDayDefault(0);
    IRoundDefault(0);
    fetch.getPkStage(
      {
        lPid: 0,
        iActId: 20201115,
        iStage: Number(props.iStage),
      },
    )
      .then((rsp: GetPkStageRsp) => {
        // console.log('PK场次', {
        //   lPid: 0,
        //   iActId: 20201115,
        //   iStage: props.iStage,
        // }, JSON.stringify(rsp));
        const dataKey: string[] = [];
        const dataValue = [];
        for (const i in rsp.mRound2Hour.value) {
          dataKey.push(i);
          dataValue.push(rsp.mRound2Hour.value[i]);
        }
        RoundKey(dataKey);
        RoundValue(dataValue);
        IDay(rsp.iDay);
        IRound(rsp.iRound);
        IDayDefault(rsp.iDay);
        IRoundDefault(rsp.iRound);
      })
  }, [props.iStage, props.iRevive])

  const [pageShow, PageShow] = useState<boolean>(true);
  const [list, List] = useState<GuildPkRoundItem[]>([]);
  const [showList, ShowList] = useState<GuildPkRoundItem[]>([]);
  const pageChange = (index: number): void => {
    ShowList(list.slice((index) * 6, (index + 1) * 6 >= list.length ? list.length : (index + 1) * 6));
  }

  useEffect(() => {
    if (iDay === 0 || iRound === 0) return;
    List([]);
    ShowList([]);
    PageShow(false);
    fetch.getGuildPkDetail(
      {
        iStage: Number(props.iStage),
        iArea: props.from === 1 ? 5 : current + 1,
        iDay,
        iRound,
        iRevive: props.from === 1 ? 0 : props.iRevive,
      },
    )
      .then((rsp: GetGuildPkDetailRsp) => {
        // console.log('公会对决', {
        //   iStage: Number(props.iStage),
        //   iArea: Number(props.from) === 1 ? 5 : current + 1,
        //   iDay,
        //   iRound,
        //   iRevive: props.from === 1 ? 0 : props.iRevive,
        // }, JSON.stringify(rsp));
        PageShow(true);
        List(rsp.vRank.value.slice(0, 30));
        ShowList(rsp.vRank.value.slice(0, 6));
      })
  }, [iDay, iRound, current])

  useEffect(() => {
    if (roundKey.length === 0 || iDayDefault === 0 || iRoundDefault === 0) return;
    let index = 0;
    for (let i = 0; i < roundKey.length; i++) {
      if (Number(roundKey[i]) === Number(iRoundDefault)) {
        index = i + 1;
      }
    }
    if (index === 0) return;
    let initTab = 0;
    if (iDayDefault === 1) {
      initTab = index > 3 ? index - 3 : 0;
    } else if (iDayDefault === 2) {
      initTab = index + 5 - 3;
    } else {
      initTab = index + 10 - 3;
    }
    new Swiper('.swiper-container-pk', {
      navigation: {
        nextEl: '#pk-next',
        prevEl: '#pk-prev',
      },
      initialSlide: initTab,
      slidesPerView: 5,
      MutationObserver: true,
    })
  }, [roundValue, iDayDefault, iRoundDefault, props.iRevive, props.iStage])
  return (
    <div
      className='web-pkRank'
      id='web-pkRank'
    >
      {
        props.from === 2 &&
        <div className='web-groupTab'>
          {
            ['游戏', '娱乐'].map((item: string, index: number) => (
              <div
                className={current === index ? 'groupTabItem on' : 'groupTabItem'}
                key={item}
                onClick={
                  () => {
                    Current(index);
                  }
                }
              >巅峰{item}公会</div>
            ))
          }
        </div>
      }
      <div className="pkRank-tab">
        <div className="swiper-button-prev" id='pk-prev'></div>
        <div className={`swiper-container swiper-container-pk swiper-no-swiping`}>
          <div className="swiper-wrapper">
            {
              (Number(props.iStage) === 1 ? [[1, roundValue], [2, roundValue], [3, roundValue]] : [[1, roundValue], [2, roundValue]]).map((item: any, index: number) => item[1].map((items: any, indexs: number) => (
                <li key={index + ':' + indexs} className='swiper-slide'>
                  <p
                    className={(iDay === item[0] && iRound === Number(roundKey[indexs])) ? 'on' : ''}
                    onClick={
                      () => {
                        IRound(Number(roundKey[indexs]));
                        IDay(item[0]);
                      }
                    }
                  >第{item[0]}日{items}时</p>
                  {
                    (iDay === item[0] && iRound === Number(roundKey[indexs])) && <i />
                  }
                </li>
              )))
            }
          </div>
        </div>
        <div className="swiper-button-next" id='pk-next'></div>
      </div>
      <ul className='pkItems'>
        {
          showList.length !== 0 ?
            showList.map((items: GuildPkRoundItem) => (
              <PkItem key={Math.random()} {...items} />
            )) :
            (
              <None text='暂无公会对决数据' />
            )
        }
      </ul>
      <div className='web-pageCover'>
        {
          pageShow &&
          <Page
            pageLen={list.length % 6 === 0 ? list.length / 6 : Math.floor(list.length / 6) + 1}
            setPageIndex={pageChange}
          />
        }
      </div>
    </div>
  )
}

export default PkRank;